module.exports = __webpack_public_path__ + "static/media/tier-5.3174ff03.jpg";